import React, { useMemo, useEffect } from 'react';
import ProductCard from '../../ProductCard';
import ContentFeed from '../../ContentFeed';

const CategoryGroup = ({
	location,
	category,
	title,
	productList,
	items,
	headline,
	showHr,
	shouldFilter = false,
	ns,
	onFilteredProducts
}) => {
  const modifiedTitle = useMemo(() => title?.replace(/\s+/g, '-').toLowerCase(), [title]);

  const productView = (product, index) => (
    <ProductCard
      location={location}
      category={category}
      product={product}
      key={product.id}
      index={index}
      hideQuickshop
      promo={category.promo.value}
      promoAmount={category.promoAmount}
      hideTag
    />
  );

  const filteredProducts = useMemo(() => {
    const productSet = new Set(productList?.split(',').map(id => parseInt(id.match(/\d+/)[0], 10)));
    return items?.filter(product => productSet.has(parseInt(product.shopifyId.match(/\d+/)[0], 10)));
  }, [productList, items]);

	useEffect(() => {
		if (onFilteredProducts) {
			onFilteredProducts(filteredProducts);
		}
	}, [filteredProducts]);

  const isFiltered = useMemo(() => filteredProducts?.length > 0, [filteredProducts]);

  const element = (
    <>
			<div className="container">
				{modifiedTitle && headline && (
					<div className={`${ns}__heading`}>
						<h3 id={modifiedTitle} className={`${ns}__heading-title`}>{title}</h3>
						<p className={`${ns}__heading-description`}>{headline}</p>
					</div>
				)}
				{filteredProducts?.length > 0 && (
					<ContentFeed
						location={location}
						page="category"
						items={filteredProducts}
						itemView={productView}
						initialVisibleAmount={4}
						nextVisibleAmount={0}
						categoryTitle={title}
					/>
				)}
			</div>
      {showHr && <hr className="main-hr" />}
    </>
  );

  return shouldFilter ? (isFiltered && element) : element;
};

export default CategoryGroup;
